import { KoobBadge } from '@koob/ui';
import { useTranslation } from 'react-i18next';

const STATE_BADGE_COLOR = {
  available: 'green',
  in_progress: 'amber',
  stand_by: 'gray',
};

export default function ProductStateBadge({ state }) {
  const { t } = useTranslation('toConnectionRequest');

  if (!state) {
    return null;
  }

  return (
    <KoobBadge color={STATE_BADGE_COLOR[state] ?? 'gray'} size="sm">
      {t(`productStateLabels.${state}`)}
    </KoobBadge>
  );
}
